import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { orgUnitsStoreStateSelector } from '~/selectors';

import { OrgTreeData } from './types';

export const useOrgTree = (): {
  orgTree: OrgTreeData[];
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
} => {
  return useSelector((state: StoreState) => {
    return orgUnitsStoreStateSelector(state);
  });
};
